import React from 'react';
import LayoutContainer from './Container';
import DomesticCourts from './DomesticCourts';
import OtherProcedures from './OtherProcedures';
import Evidence from './Evidence';
import Legislation from './Legislation';
import '../styles/maincontent.css';
import '../styles/cards.css';

const Documents = () => {
  const petitionURL = "https://petition.parliament.uk/petitions/660652";

  return (
    <LayoutContainer>
      <div className="main-content">
        <div className="content-row align-items-center">
          <a href={petitionURL} target="_blank" rel="noopener noreferrer" className="qr-image-container">
            <img src="images/qr-code.jpg" alt="QR Code" className="img-fluid qr-col" />
          </a>
          <h1 className="left-title">Documents for UN CRPD Committee</h1>
        </div>
        {/* Sub-documents */}
        <div className="grid-container">
          <div className="card">
            <DomesticCourts />
          </div>
          <div className="card">
            <OtherProcedures />
          </div>
          <div className="card">
            <Evidence />
          </div>
          <div className="card">
            <Legislation />
          </div>
        </div>
      </div>
    </LayoutContainer>
  );
}

export default Documents;

